function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { safeGlobal } from '@amplitude/experiment-core';
export class Backoff {
  constructor(attempts, min, max, scalar) {
    _defineProperty(this, "attempts", void 0);

    _defineProperty(this, "min", void 0);

    _defineProperty(this, "max", void 0);

    _defineProperty(this, "scalar", void 0);

    _defineProperty(this, "started", false);

    _defineProperty(this, "done", false);

    _defineProperty(this, "timeoutHandle", void 0);

    this.attempts = attempts;
    this.min = min;
    this.max = max;
    this.scalar = scalar;
  }

  async start(fn) {
    if (!this.started) {
      this.started = true;
    } else {
      throw Error('Backoff already started');
    }

    await this.backoff(fn, 0, this.min);
  }

  cancel() {
    this.done = true;
    clearTimeout(this.timeoutHandle);
  }

  async backoff(fn, attempt, delay) {
    if (this.done) {
      return;
    }

    this.timeoutHandle = safeGlobal.setTimeout(async () => {
      try {
        await fn();
      } catch (e) {
        const nextAttempt = attempt + 1;

        if (nextAttempt < this.attempts) {
          const nextDelay = Math.min(delay * this.scalar, this.max);
          this.backoff(fn, nextAttempt, nextDelay);
        }
      }
    }, delay);
  }

}
//# sourceMappingURL=backoff.js.map